import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { DpFichasComponent } from './dp-fichas.component';

@NgModule({
  declarations: [DpFichasComponent],
  exports: [DpFichasComponent],
  imports: [CommonModule, FormsModule, PoModule]
})
export class DpFichasModule {}
